export default __webpack_public_path__ + "static/media/beach.f4dc0b85.gif";